/**
 * Configuration des images professionnelles pour Community ImpactInvest
 * Thématiques : Finance durable, Impact social Afrique, Investissement responsable
 * Nouvelles sections : Nos Réalisations, Nos Valeurs, Plateforme d'Investissement
 */

// Images principales Hero Section
export const heroImages = {
  // Images locales authentiques Community ImpactInvest
  local: {
    main: '/src/assets/icones/ImpactInvest.jpg',
    community: '/src/assets/icones/communityPhoto.jpg',
    impact: '/src/assets/icones/impact invest.jpg',
    alt: 'Images authentiques des projets Community ImpactInvest au Niger',
    credit: 'Community ImpactInvest - Projets authentiques',
    theme: 'Impact réel, développement durable Niger'
  },
  
  // Image principale Hero - Impact social en Afrique (fallback)
  main: {
    src: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
    alt: 'Agriculture durable et développement communautaire en Afrique',
    credit: 'Unsplash - Gratuit',
    theme: 'Agriculture durable, communauté rurale africaine'
  },
  
  // Images d'arrière-plan alternatives
  alternatives: [
    {
      src: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
      alt: 'Femmes entrepreneures africaines travaillant ensemble',
      credit: 'Unsplash - Gratuit',
      theme: 'Entrepreneuriat féminin, collaboration'
    },
    {
      src: 'https://images.unsplash.com/photo-1601933470096-0e34634ffcde?ixlib=rb-4.0.3&auto=format&fit=crop&w=2070&q=80',
      alt: 'Technologies propres et énergie solaire en Afrique',
      credit: 'Unsplash - Gratuit',
      theme: 'Énergie renouvelable, technologie verte'
    }
  ]
};

// Images pour sections d'engagement et impact
export const impactImages = {
  finance: {
    src: 'https://images.unsplash.com/photo-1551836022-deb4988cc6c0?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    alt: 'Finance moderne et investissement responsable',
    credit: 'Unsplash - Gratuit',
    theme: 'Graphiques financiers, données, technologie'
  },
  
  community: {
    src: 'https://images.unsplash.com/photo-1559027615-cd4628902d4a?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    alt: 'Communauté africaine unie pour le développement',
    credit: 'Unsplash - Gratuit',
    theme: 'Communauté, solidarité, développement'
  },
  
  agriculture: {
    src: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    alt: 'Agriculture moderne et durable en Afrique',
    credit: 'Unsplash - Gratuit',
    theme: 'Agriculture durable, innovation agraire'
  },
  
  education: {
    src: 'https://images.unsplash.com/photo-1497486751825-1233686d5d80?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    alt: 'Éducation et formation en Afrique',
    credit: 'Unsplash - Gratuit',
    theme: 'Éducation, formation, développement des compétences'
  },

  technology: {
    src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    alt: 'Innovation technologique en Afrique',
    credit: 'Unsplash - Gratuit',
    theme: 'Technologies mobiles, innovation digitale'
  },

  environment: {
    src: 'https://images.unsplash.com/photo-1441974231531-c6227db76b6e?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80',
    alt: 'Protection environnementale et développement durable',
    credit: 'Unsplash - Gratuit',
    theme: 'Écologie, forêts, biodiversité'
  }
};

// Images pour "Nos Réalisations" 
export const achievementsImages = {
  infrastructure: {
    src: 'https://images.unsplash.com/photo-1581094794329-c8112a89af12?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Infrastructure moderne construite grâce aux investissements',
    credit: 'Unsplash - Gratuit',
    theme: 'Construction, infrastructures, développement urbain'
  },
  
  success_stories: {
    src: 'https://images.unsplash.com/photo-1552664730-d307ca884978?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Équipe célébrant le succès d\'un projet d\'impact',
    credit: 'Unsplash - Gratuit',
    theme: 'Succès, collaboration, réussite collective'
  },
  
  transformation: {
    src: 'https://images.unsplash.com/photo-1559827260-dc66d52bef19?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Transformation positive des communautés',
    credit: 'Unsplash - Gratuit',
    theme: 'Transformation sociale, développement communautaire'
  }
};

// Images pour "Nos Valeurs"
export const valuesImages = {
  transparency: {
    src: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Transparence et responsabilité dans la gestion',
    credit: 'Unsplash - Gratuit',
    theme: 'Transparence, accountability, gouvernance'
  },
  
  sustainability: {
    src: 'https://images.unsplash.com/photo-1593113598332-cd288d649433?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Développement durable et respect de l\'environnement',
    credit: 'Unsplash - Gratuit',
    theme: 'Durabilité, écologie, avenir'
  },
  
  inclusion: {
    src: 'https://images.unsplash.com/photo-1517048676732-d65bc937f952?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Inclusion et diversité dans nos équipes',
    credit: 'Unsplash - Gratuit',
    theme: 'Diversité, inclusion, équité'
  },
  
  innovation: {
    src: 'https://images.unsplash.com/photo-1519389950473-47ba0277781c?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Innovation et solutions créatives',
    credit: 'Unsplash - Gratuit',
    theme: 'Innovation, créativité, solutions'
  }
};

// Images pour "Plateforme d'Investissement à Impact"
export const platformImages = {
  dashboard: {
    src: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Interface moderne de la plateforme d\'investissement',
    credit: 'Unsplash - Gratuit',
    theme: 'Technologie, interface, données'
  },
  
  impact_metrics: {
    src: 'https://images.unsplash.com/photo-1590479773265-7464e5d48118?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Métriques d\'impact et analyse de performance',
    credit: 'Unsplash - Gratuit',
    theme: 'Analytics, métriques, performance'
  },
  
  global_reach: {
    src: 'https://images.unsplash.com/photo-1506905925346-21bda4d32df4?ixlib=rb-4.0.3&auto=format&fit=crop&w=1200&q=80',
    alt: 'Portée mondiale de nos investissements d\'impact',
    credit: 'Unsplash - Gratuit',
    theme: 'Monde, connexions, impact global'
  }
};

// Images des projets avec catégorisation améliorée
export const projectImages = {
  // Agriculture et développement rural
  agricultureBio: {
    src: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Ferme écologique moderne avec légumes bio',
    credit: 'Unsplash - Gratuit',
    category: 'Agriculture'
  },
  
  // Technologies et innovation
  startupTech: {
    src: 'https://images.unsplash.com/photo-1522071820081-009f0129c71c?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Équipe de startup technologique africaine',
    credit: 'Unsplash - Gratuit',
    category: 'Technologie'
  },
  
  // Éducation et formation
  centreFormation: {
    src: 'https://images.unsplash.com/photo-1544717297-fa95b6ee9643?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Centre de formation moderne en Afrique',
    credit: 'Unsplash - Gratuit',
    category: 'Éducation'
  },
  
  // Énergie renouvelable
  energieSolaire: {
    src: 'https://images.unsplash.com/photo-1509391366360-2e959784a276?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Installation solaire dans village africain',
    credit: 'Unsplash - Gratuit',
    category: 'Énergie'
  },
  
  // Santé et bien-être
  centresSante: {
    src: 'https://images.unsplash.com/photo-1538108149393-fbbd81895907?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Centre de santé moderne en Afrique',
    credit: 'Unsplash - Gratuit',
    category: 'Santé'
  },
  
  // Micro-finance
  microfinance: {
    src: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Femmes bénéficiant de micro-crédit',
    credit: 'Unsplash - Gratuit',
    category: 'Finance'
  },
  
  // Infrastructure urbaine
  developpementUrbain: {
    src: 'https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Développement urbain durable',
    credit: 'Unsplash - Gratuit',
    category: 'Infrastructure'
  },
  
  // Artisanat et commerce équitable
  artisanat: {
    src: 'https://images.unsplash.com/photo-1565193566173-7a0ee3dbe261?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Artisans locaux produisant objets traditionnels',
    credit: 'Unsplash - Gratuit',
    category: 'Artisanat'
  }
};

// Images premium pour upgrade futur
export const premiumImages = {
  // Suggestions d'achat premium pour authenticité maximale
  africanEntrepreneurs: {
    suggestion: 'Getty Images - African entrepreneurs in meeting',
    cost: '~12€',
    theme: 'Entrepreneurs africains authentiques'
  },
  
  nigerLandscape: {
    suggestion: 'Shutterstock - Niger rural development',
    cost: '~10€',
    theme: 'Paysages et développement Niger'
  }
};

// Images de témoignages avec portraits authentiques
export const testimonialImages = {
  ceo_woman: {
    src: 'https://images.unsplash.com/photo-1580489944761-15a19d654956?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    alt: 'Femme CEO entreprise sociale africaine',
    credit: 'Unsplash - Gratuit',
    name: 'Aïcha Mamane',
    role: 'CEO StartupTech Niger'
  },
  
  farmer_leader: {
    src: 'https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    alt: 'Leader communautaire agricole',
    credit: 'Unsplash - Gratuit',
    name: 'Ibrahim Touré',
    role: 'Président Coopérative Agricole'
  },
  
  educator: {
    src: 'https://images.unsplash.com/photo-1560250097-0b93528c311a?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    alt: 'Directrice centre formation',
    credit: 'Unsplash - Gratuit',
    name: 'Fatima Al-Zahra',
    role: 'Directrice Formation Professionnelle'
  },
  
  entrepreneur: {
    src: 'https://images.unsplash.com/photo-1574943320219-553eb213f72d?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80',
    alt: 'Jeune entrepreneur tech',
    credit: 'Unsplash - Gratuit',
    name: 'Mohamed Garba',
    role: 'Fondateur EcoTech Solutions'
  }
};

// Images pour la page Features/Avantages
export const featuresImages = {
  impactPositif: {
    src: 'https://images.unsplash.com/photo-1555689502-c4b22d76c56f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Impact social positif et développement durable',
    credit: 'Unsplash - Gratuit',
    category: 'Impact Social'
  },
  
  rendementsAttractifs: {
    src: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Graphiques financiers montrant rendements attractifs',
    credit: 'Unsplash - Gratuit',
    category: 'Finance'
  },
  
  securiteMaximale: {
    src: 'https://images.unsplash.com/photo-1563986768609-322da13575f3?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Sécurité et protection des données',
    credit: 'Unsplash - Gratuit',
    category: 'Sécurité'
  },
  
  tableauDeBord: {
    src: 'https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Interface dashboard moderne et intuitive',
    credit: 'Unsplash - Gratuit',
    category: 'Technologie'
  },
  
  communauteInvestisseurs: {
    src: 'https://images.unsplash.com/photo-1556761175-b413da4baf72?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Communauté diverse d\'investisseurs engagés',
    credit: 'Unsplash - Gratuit',
    category: 'Communauté'
  },
  
  formationAccompagnement: {
    src: 'https://images.unsplash.com/photo-1522202176988-66273c2fd55f?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80',
    alt: 'Formation et accompagnement personnalisé',
    credit: 'Unsplash - Gratuit',
    category: 'Éducation'
  }
};

// Configuration technique pour optimisation
export const imageConfig = {
  // Formats supportés par ordre de préférence
  formats: ['webp', 'jpg', 'png'],
  
  quality: {
    high: 90,
    medium: 75,
    low: 60
  },
  
  loading: 'lazy', // Lazy loading par défaut
  
  placeholder: 'data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTAwIiBoZWlnaHQ9IjEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMTAwJSIgaGVpZ2h0PSIxMDAlIiBmaWxsPSIjZGRkIi8+PC9zdmc+'
};

const defaultExport = {
  heroImages,
  impactImages,
  achievementsImages,
  valuesImages,
  platformImages,
  projectImages,
  premiumImages,
  testimonialImages,
  featuresImages,
  imageConfig
};

export default defaultExport;